var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCentral = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16166_56479)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5332 3.23015L11.5332 21.1351C11.5332 21.5944 11.9056 21.9668 12.3649 21.9668C12.8242 21.9668 13.1965 21.5944 13.1965 21.1351L13.1965 3.23015C13.1965 2.77107 12.8239 2.39849 12.3649 2.39849C11.9058 2.39849 11.5332 2.77107 11.5332 3.23015Z",
    fill: "#5C5F62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5317 13.2668L23.098 13.2668C23.5951 13.2668 23.998 12.8639 23.998 12.3668C23.998 11.8697 23.5951 11.4668 23.098 11.4668L18.5317 11.4668L18.5317 8.7668L14.9407 12.3668L18.5317 15.9668L18.5317 13.2668Z",
    fill: "#5C5F62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46437 11.4666L0.898047 11.4666C0.400991 11.4666 -0.0019533 11.8695 -0.00195333 12.3666C-0.00195335 12.8637 0.40099 13.2666 0.898046 13.2666L5.46437 13.2666L5.46437 15.9666L9.05537 12.3666L5.46437 8.7666L5.46437 11.4666Z",
    fill: "#5C5F62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16166_56479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCentral, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/central.1a65be8f.svg";
export { ForwardRef as ReactComponent };